import { createBrowserRouter } from "react-router-dom";
import About from "../Components/Home/About/About";
import Blog from "../Components/Home/Blog/Blog";
import Certifications from "../Components/Home/Certifications/Certifications";
import Contact from "../Components/Home/Contact/Contact";
import Home from "../Components/Home/Home/Home";
import Projects from "../Components/Home/Projects/Projects";
import Main from "../Layout/Main";

const router = createBrowserRouter([
{
path: '/',
element: <Main></Main>,

children: [
{
path: '/',
element: <Home></Home>
},
{
path: '/about',
element: <About></About>
},
{
path: '/projects',
element: <Projects></Projects>
},
{
path: '/blog',
element: <Blog></Blog>
},
{
path: '/certifications',
element: <Certifications></Certifications>
},
{
path: '/contact',
element: <Contact></Contact>
},


]
}

])

export default router;
